module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-ornamental-rectangular.0c9c96a3.jpg";